export const es = {
    //Elementos generales
    "Clic here": "Haz clic aquí",
    "Edit": "Editar",
    "Preview": "Vista previa",
    "Saving":"Guardando...",
    "Cancel": "Cancelar",
    "Save": "Guardar",
    "firstName": "Nombre",
    "lastName": "Apellidos",
    "back": "Volver",
    "email": "Correo electrónico",
    "emailExample": "correo@correo.com",
    "completeName": "Nombre Completo",
    "years": "Years",
    "months": "Months",
    "days": "Dias",
    "hours": "Horas",
    "minutes": "Minutos",
    "year": "Year",
    "month": "Month",
    "day": "Día",
    "hour": "Hora",
    "minute": "Minuto",
    "lessons": "Lecciones",
    "courses": "Cursos",
    "lesson": "Lección",
    "course": "Curso",
    "search": "Buscar",
    "studentsName": "Nombre del estudiante",
    "progressByLessonBusiness": "Avance por lección",
    "lessonsCompleted": "Lessons completed",
    "fieldRequired": "Este campo es obligatorio",
    "fieldInvalid": "Ya en uso ó inválido",
    "publish": "Publicar",
    "customerId": "Folio de contrato",
    "phoneNumber": "Número de teléfono",
    "submitRequest": "Enviar solicitúd",
    "available": "Disponible",
    "ok": 'Entendido',
    "ssn": "CURP", 
    "profession": "Profesión",
    "userName": "Nombre de usuario",
    "nickname": "Alias",
    "password": "Contraseña",
    "newPassword": "Nueva contraseña",
    "confirmPassword": "Confirma tu contraseña",
    "passwordDontMatch": "Las contraseñas no coinciden",
    "passwordMatch": "Las contraseñas coinciden",
    "passwordRequirements": "Tu contraseña debe contener:",
    "passwordBeTheSame": "Las contraseñas deben ser las mismas",
    "characters": "8 caracteres",
    "capitalLetter": "1 letra mayúscula",
    "numberRequired": "1 número",
    "deactivateUser": "Desactivar usuario",
    "activateUser": "Activar usuario",
    "leavingClick": "Saliendo de Click+",
    "leavingClickMessage": "Estás a punto de ser redirigido al sitio de pago",





    "Welcome to React": "Bienvenido a react",
    "Log In": "Inicio de sesión",
    "Username": "Nombre de usuario",
    "Password": "Contraseña",
    //Home
    "You can start with": "Puedes comenzar con:",
    "Get the user manual": "Descarga el manual de usuario",
    "Welcome title": "!Bienvenido/a ",
    "Continue title": "Continúa donde lo dejaste",
    "Continue where you left off": "Regresa a tu aprendizaje desde tu última lección vista.",
    "Advances": "Mis Avances",
    "My Advances": "Revisa tu progreso de aprendizaje, tu tiempo en la plataforma y tu última lección visualizada.",
    "Diagnostic title": "Exámen diagnóstico",
    "Diagnostic examination": "Pon a prueba tus conocimientos de Excel y Power BI y obtén un diagnóstico para saber qué temas reforzar antes de tomar tus cursos.",
    "Learning title": "Rutas de aprendizaje",
    "Learning routes": "Crea listas personalizadas con temas de nuestro catálogo de cursos que te interesen.",
    "Entertainment title": "Sala de entretenimiento",
    "Entertainment room": "Entra a la sala de entretenimiento y relájate un momento antes de continuar con tu aprendizaje.",
    "Consulting title": "Agenda de asesorías",
    "Consulting agenda": "¿Necesitas ayuda con temas de paquetería Office? Agenda una consulta con uno de nuestros especialistas y con gusto te apoyaremos.",
    "Pomodoro title": "Técnica Pomodoro",
    "Pomodoro Technique": "Maximiza tu concentración con esta técnica de gestión del tiempo que te ayudará a organizar el tiempo que dedicas a tu aprendizaje.",
    //Pendiente para traducir, falta la app movil
    //   "Download Click+ Mobile": "Administra tu progreso, solicita tu estado de cuenta y disfruta lecciones optimizadas para que las lleves contigo donde quieras. Sin costo adicional.",
    "Admin title": "Panel de administración",
    "Admin Panel": "Gestiona el contenido de la plataforma.",
    "Just for you": "Seleccionado para ti",
    "You might be interested": "Podria interesarte",
    "MOS title": "Certificación MOS",
    "MOS description" : "Prepárate para tu Certificado Microsoft Office Specialist Te ayudará a mejorar tu análisis de datos, la toma de decisiones y optimización de procesos, además de destacar para mejores puestos y oportunidades laborales.",
    "Material seen in training": "Material visto en capacitación",
    "See material": "Ver material",
    "Reviews from our customers": "Reseñas de nuestros clientes",
    "Reviews description" : "Mira los comentarios de nuestras asesorías personalizadas",

    //Atajos para nuevo ingreso
    "Diagnostic test":"Examen diagnóstico",
    "Diagnostic description":"Prueba tu conocimiento en Excel y Power BI y obtén un diagnóstico para saber que temas reforzar antes de tomar tus cursos.",
    "Learning paths": "Rutas de aprendizaje",
    "Learning description" : "Crea listas de reproducción personalizadas con temas de nuestro catálogo de cursos que sea de tu interés.",


    //Listado de cursos
    "selectCategory": "Selecciona una categoría",
    "selectCourse": "Selecciona un curso",
    "backToCategories": "Regresar a las categorías",

    //Listado de cursos(Descripciones de las categorias)
    "About": "¿De qué va la categoría?",
    "Aprende a utilizar herramientas que agilizan el uso de la computadora como comandos y atajos de Windows, o sobre el uso del Navegador Web con Internet": "Aprende a utilizar herramientas que agilizan el uso de la computadora como comandos y atajos de Windows, o sobre el uso del Navegador Web con Internet",
    "Aprende sobre edición de imágenes con la Paquetería Adobe": "Aprende sobre edición de imágenes con la Paquetería Adobe",
    "Utiliza la Paquetería Office que te ayudarán a realizar tus trabajos de manera eficiente": "Utiliza la Paquetería Office que te ayudarán a realizar tus trabajos de manera eficiente",
    "Analiza y procesa tus datos de ventas y mejorar tus procesos con Power Business Intelligence": "Analiza y procesa tus datos de ventas y mejorar tus procesos con Power Business Intelligence",
    "Obtendrás conocimientos en las herramientas más utilizadas en Home Office como Microsoft Teams, Hangouts o Zoom": "Obtendrás conocimientos en las herramientas más utilizadas en Home Office como Microsoft Teams, Hangouts o Zoom",
    "Aprende programación por bloques con Scratch o a hacer carritos de compra en línea en minutos con Wordpress": "Aprende programación por bloques con Scratch o a hacer carritos de compra en línea en minutos con Wordpress",
    "Conoce conceptos básicos de la Programación Neurolingüística y aprende cómo utilizarlos": "Conoce conceptos básicos de la Programación Neurolingüística y aprende cómo utilizarlos",
    "Adquiere conocimientos básicos y avanzados en el idioma Inglés": "Adquiere conocimientos básicos y avanzados en el idioma Inglés",
    "Adquiere conocimientos en las herramientas necesarias para crear tu tienda en línea": "Adquiere conocimientos en las herramientas necesarias para crear tu tienda en línea",

    //Categorias de la plataforma
    "Informática": "Informática",
    "Diseño": "Diseño",
    "Ofimática": "Ofimática",
    "Inteligencia de Negocios": "Inteligencia de ventas",
    "Home Office": "Home Office",
    "Programación": "Programación",
    "Desarrollo personal": "Desarrollo personal",
    "Idiomas": "Idiomas",
    "E-commerce": "E-commerce",
    //TODO: Falta complementar las categorias con las de los intereses


    //Cursos de la plataforma
    "Internet": "Internet   ",
    "Windows 10": "Windows 10",
    "Photoshop": "Photoshop",
    "Excel Aplicado" : "Excel Aplicado",
    "Excel Intermedio": "Excel Intermedio",
    "Excel Básico": "Excel Básico",
    "Outlook": "Outlook",
    "PowerPoint": "PowerPoint",
    "Word": "Word",
    "Power BI": "Power BI",
    "Power BI Avanzado": "Power BI Avanzado",
    "Microsoft Teams": "Microsoft Teams",
    "Zoom": "Zoom",
    "Programación por bloques con Scratch": "Programación por bloques con Scratch",
    "Comunicación Efectiva": "Comunicación Efectiva",
    "Liderazgo": "Liderazgo",
    "Resiliencia": "Resiliencia",
    "Ética profesional": "Ética profesional",
    "Programación Neurolingüística": "Programación Neurolingüística",
    "Programación Neurolingüística para ventas": "Programación Neurolingüística para ventas",
    "Resolución de conflictos": "Resolución de conflictos",
    "English Beginning":"English Beginning",
    "English Intermediate": "English Intermediate",
    "English High Intermediate":"English High Intermediate",
    "Canva Pro": "Canva Pro",
    "Canva": "Canva",
    "Meta Suite Bussiness": "Meta Suite Bussiness",
    "WordPress": "WordPress",

    "Courses you will find here":"Cursos que encontrarás aquí",

    //navbar
    "Display menu": "Desplegar menú",
    "Search by categories, courses, sections, lessons, learning paths, quick tips, or help forum topics": "Busca por categorías, cursos, secciones, lecciones, rutas de aprendizaje, consejos rápidos o temas de foro de ayuda",
    "Without notifications":"No tienes notificaciones",

    "Pomodoro technique": "Técnica pomodoro",
    "Settings": "Configuración",
    "Notifications": "Notificaciones",
    "Add second user": "Registrar 2° usuario",
    "Change user": "Cambiar usuario",
    "Change password": "Cambiar contraseña",
    "Change username": "Cambiar nombre de usuario",
    "Log out": "Cerrar sesión",


    //Configuracion
    "Settings title": "Configuración",
    "My profile": "Mi perfil",
    "Your account": "Tu cuenta",
    "Contract id": "Folio de contrato",
    "Email": "Email",
    "First name": "Nombre",
    "Last name": "Apellidos",
    "Phone": "Número de teléfono",
    "Username":"Nombre de usuario",
    "Nickname": "Alias de usuario",
    "Profession":"Profesión",
    "Your preferences": "Tus intereses",
    "No preferences": "No has seleccionado tus temas de interés",
    "Select preferencies": "Seleccionar intereses",
    "Your membership": "Tu membresía",
    "License": "Licencia",
    "Role": "Rol",
    "Registration date": "Fecha de registro",
    "Last login": "Fecha de último acceso", 
    "Expiration date": "Fecha de expiración",
    "Remaining time": "Tiempo restante",
    "Courses included in my license": "Mis cursos",

    //Dropzone component
    "dropzone description": "Haz clic aquí para cargar una foto",

    //Sidebar
    "Home":"Inicio",
    "Home description":"Regresa al menú principal",
    "Click+ Misions":"Misiones Click+",
    "Click+ Misions description":"Completa los retos, gana créditos y canjealos por increíbles premios",
    "Quick tips": "Consejos Rápidos",
    "Quick tips description" : "Aumenta tu productividad con la lista de atajos de teclado que tenemos para consultar, en ella encontrarás atajos para toda la paquetería Office y cursos con los que cuenta la plataforma",
    "Help forum notifications": "Foro de Ayuda: Notificaciones Nuevas",
    "Help forum": "Foro de Ayuda",
    "Help forum description": "Interactúa con la comunidad Click+ y comparte temas, opiniones o resuelve dudas que surjan durante tu aprendizaje con apoyo de otros estudiantes",
    "My courses": "Mis Cursos",
    "My courses description": "Disfruta del catálogo de cursos que tenemos para ti. ¡Complétalos todos!",
    "AI Suite": "Suite IA",
    "AI Suite description": "La inteligencia artificial incrementa la productividad y calidad en tu trabajo, explora las diferentes herramientas con inteligencia artificial y libera todo su potencial para aplicarlos en tu día a día",
    "Bussiness forum": "Foro Empresarial",
    "Bussiness forum description": "Mantente en constante contacto con tus colaboradores al asignar tareas o actividades, lleva el control y administra a tu equipo generando un reporte del avance de sus integrantes y de su actividad en la plataforma",
    "Help center": "Centro de Ayuda",
    "Help center description": "¿Necesitas ayuda? Consulta las preguntas más frecuentes para resolver tus dudas que tengas sobre la plataforma y temas de tu licencia Click+",
    "My payments": "Mis pagos",
    "My payments description": "Solicíta tu estado de cuenta o renueva tu licencia Click+.",
    "MOS preparatory course": "Curso Propedéutico MOS",
    "MOS preparatory course description": "Prepárate y mira todos los requisitos previos para tu examen de certificación MOS, cuando estés listo podrás agendar la fecha para tu examen de certificación",

    //FAQ 

    "dashboardFAQ": {
    "breadcrumb": {
      "title": "Preguntas frecuentes"
    },
    "pageTitle": "Preguntas frecuentes",
    "navigation": {
      "platform": "Uso de la plataforma",
      "groups": "Grupos Empresariales",
      "certifications": "Certificaciones",
      "consulting": "Asesoría personalizada",
      "others": "Otros"
    },
    "sections": {
      "platform": {
        "q1": {
          "question": "¿Cómo registro a mi segundo usuario?",
          "answer": "Si eres titular de una licencia <strong>Click+ Premium</strong>, encontrarás el formulario de registro en la esquina superior derecha al dar clic sobre tu nombre en la opción <strong>\"Registrar 2do usuario\"</strong>. Al finalizar, tu compañero recibirá un correo de confirmación y deberás compartir con él tus credenciales de acceso. Recuerda que la información de acceso es compartida, sin embargo, dentro de la cuenta encontrás un perfil para ti y tu segundo usuario."
        },
        "q2": {
          "question": "¿Por dónde empezar?",
          "answer": {
            "p1": "Toma una ruta de aprendizaje, la cual tiene un listado de lecciones que te ayudarán a desarrollar una habilidad ofimática en específico.",
            "p2": "Evaluar tus conocimientos en Excel y Power BI, con un examen diagnóstico. Al finalizar, obtendrás una retroalimentación con el nivel de Excel/Power BI, en el que te encuentras y una serie de lecciones que te ayudarán a mejorar tus habilidades.",
            "p3": "Inicia el curso de tu interés. En la página principal encontrarás un listado de categorías de estudio, que las conforman los mejores cursos de ofimática que te ayudarán en tu crecimiento profesional."
          }
        },
        "q3": {
          "question": "¿Por dónde empezar?",
          "answer": {
            "p1": "Comienza con tu aprendizaje dando clic en el apartado de Mis Cursos en la barra lateral de navegación o seleccionando uno de los cursos que tienes disponibles desde la página de inicio, selecciona una categoría y luego uno de los cursos que esa categoría tiene para ti.",
            "p2": "Una vez que comiences con tu curso, iras registrando tus avances y puedes vizualizarlo en el apartado de Mis Avances, igualmente ubicado en la barra lateral de navegación de tu plataforma.",
            "p3": "Con esto, estás listo para comenzar con tu aprendizaje en Click+."
          }
        },
        "q4": {
          "question": "¿Qué temas trata el examen diagnóstico?",
          "answer": "Excel y Power Business Intelligence (Power BI), al finalizar recibirás retroalimentación con lecciones sugeridas de acuerdo a tu nivel de conocimiento, para reforzar y aprender nuevas habilidades."
        },
        "q5": {
          "question": "Material visto en capacitación",
          "answer": "Si algo no quedó claro, aquí encontrarás las lecciones de apoyo, utilizadas en tu capacitación empresarial impartida por un instructor."
        },
        "q6": {
          "question": "¿Qué es una ruta de aprendizaje?",
          "answer": "Es una lista de reproducción, de lecciones ordenadas de acuerdo al nivel de conocimientos que necesitas para adquirir cierta habilidad ofimática en específico."
        },
        "q7": {
          "question": "¿Qué son los consejos rápidos?",
          "answer": "Son atajos/comandos de distintos programas que te servirán para ser cada vez más ágil en el manejo de las aplicaciones ofimáticas."
        },
        "q8": {
          "question": "¿Cómo utilizar el Foro de Ayuda?",
          "answer": "Puedes agregar una publicación, donde redactes alguna duda relacionada a los temas vistos en los diferentes cursos. Un experto y la comunidad en general responderá a tu pregunta con el fin de lograr un conocimiento colectivo y una interacción entre los estudiantes."
        },
        "q9": {
          "question": "¿Cómo posicionarme en el Ranking de un curso?",
          "answer": "Al término de la evaluación final de cada curso, tu calificación quedará registrada y de acuerdo a tu resultado estarás posicionado en el Ranking, entre más alta sea, mejor."
        },
        "q10": {
          "question": "¿Cómo marcar una lección como completada?",
          "answer": "Cada lección cuenta con una casilla que podrás marcar cuando completada, cuando te sientas listo para avanzar a la siguiente lección, así llevarás un mejor control a tu ritmo."
        },
        "q11": {
          "question": "¿Cómo puedo saber mi avance general?",
          "answer": "En la página principal encontrarás un acceso directo (ícono de gráficos de barra) o puedes ingresar desde la opción del menú lateral \"Mis avances\"."
        },
        "q12": {
          "question": "¿Cómo cambio mi contraseña?",
          "answer": "En el menú desplegable de usuario, elige \"Mi perfil\" y selecciona la pestaña de \"Cambio de contraseña\", recibirás un código de verificación en tu correo que deberás insertar para confirmar tu identidad."
        },
        "q13": {
          "question": "¿Puedo ver las lecciones desde mi dispositivo móvil?",
          "answer": "Sí, las actividades pueden visualizarse en cualquier dispositivo, sin embargo, te recomendamos trabajar en dispositivo de escritorio, así podrás llevar tus conocimientos a la práctica usando los comandos necesarios."
        }
      },
      "groups": {
        "q1": {
          "question": "¿Cómo puedo agregar un nuevo integrante a mi grupo?",
          "answer": "Para realizar el registro de un integrante a tu grupo empresarial, deberás ingresar a Foro Empresarial > Colaboradores y hacer clic en el botón 'Nuevo colaborador'. Una vez dado de alta, el nuevo integrante de tu equipo podrá ingresar a la plataforma con su usuario y contraseña asignados previamente."
        },
        "q2": {
          "question": "¿Para qué sirve el foro empresarial?",
          "answer": "Es un espacio exclusivo para un grupo empresarial, en el que todos los integrantes de un grupo visualizan el contenido personalizado, creado con base a las necesidades y solicitudes de la empresa, y en el caso del Asesor (Titular de la cuenta) puede ver el avance individual de cada integrante."
        },
        "q3": {
          "question": "¿Qué es una lección empresarial?",
          "answer": "Es una lección interactiva totalmente personalizada, dirigida a tu grupo de colaboradores, que sirve como temario de capacitación para tu empresa. Puedes solicitarlas en la sección Grupo Empresarial > Lecciones."
        },
        "q4": {
          "question": "¿Qué es una publicación empresarial?",
          "answer": "A diferencia de la lección empresarial, una publicación es una nota breve que puede realizar el asesor, consta de una descripción y una plantilla auxiliar que los colaboradores de un grupo pueden ver y descargar. Es útil para fines informativos internos de la empresa."
        }
      },
      "certifications": {
        "q1": {
          "question": "¿Cómo obtengo mi certificado de finalización de curso?",
          "answer": "Al final de las lecciones de cada curso encontrarás un examen final, el cual, deberá ser aprobado con un mínimo de 85% de calificación, si cumple con esta condición, entonces podrás emitir tu certificado de forma automática."
        },
        "q2": {
          "question": "¿Qué necesito para obtener mi certificación MOS?",
          "answer": "Revisa la sección exclusiva del Curso Propedéutico MOS, ahí encontrarás toda la información a detalle para poder adquirir tu certificación respaldada por Microsoft."
        }
      },
      "consulting": {
        "q1": {
          "question": "¿Cómo solicito una asesoría personalizada?",
          "answer": {
            "p1": "Agenda una asesoría personalizada para resolver cualquier duda relacionada a temas de Office, en prácticas o proyectos personales.",
            "p2": "Solicítala a través del Módulo de Agendas de Asesorías disponible desde tu plataforma Click+."
          }
        }
      },
      "others": {
        "q1": {
          "question": "¿No encontraste una respuesta?",
          "answer": {
            "line1": "Contacta a uno de nuestros asesores a través del chat en línea, puedes encontrar el botón de color azul en la esquina inferior derecha.",
            "line2": "Teléfono de oficinas: 477 390 83 01, ext. 101 ó 102",
            "line3": "Horarios: Lunes a Viernes: 8:30 a.m. a 8:00 p.m. y Sábados: 8:00 a.m. a 2:00 p.m"
          }
        }
      }
    }
  },

  //CursoPropedeutico
  "cursoPropedeutico": {
    "breadcrumb": {
      "title": "Curso propedéutico"
    },
    "pageTitle": "Curso Propedéutico MOS",
    "tabs": {
      "propedeutico": "Curso Propedéutico",
      "info": "Certificación MOS",
      "certificaciones": "Certificaciones adquiridas"
    },
    "tour": {
      "step1": "Bienvenido al apartado de propedéutico MOS, aquí te proporcionamos un entorno de práctica para prepararte para tu examen de certificación MOS.",
      "step2": "A tu izquierda te hemos listado tanto las lecciones como un ejercicio para practicar junto con un archivo descargable donde podrás llevar un mejor control a la hora de practicar.",
      "step3": "Aquí se mostrarán las lecciones interactivas.",
      "step4": "Es hora de que practiques, no esperes más, ¡buena suerte!"
    },
    "timeline": {
      "manual": {
        "title": "Manual del simulador",
        "description": "Como primer paso para agendar tu examen, te prepararemos en un ambiente de simulación, en el que tendrás 4 intentos para prepararte y te sientas seguro al momento de presentar la certificación oficial, a continuación podrás descargar el manual para acceder al ambiente de simulación.",
        "button": "Descargar PDF"
      },
      "process": {
        "title": "Proceso de examen",
        "description": "Luego de acceder al ambiente de simulación es necesario seguir el siguiente proceso para el registro al examen de certificación.",
        "button": "Descargar PDF"
      },
      "certiport": {
        "title": "Cuenta Certiport",
        "description1": "Es necesario que tengas una cuenta activa en Certiport ya que desde aquí se realizará el examen de certificación una vez completes estos pasos y agendes tu cita.",
        "description2": "Si aún no tienes tu cuenta, da clic en el siguiente enlace para crear tu cuenta.",
        "alert1": "Dentro del formulario de registro, llena todos los campos a excepción del campo 'Student Number'.",
        "alert2": "Al agendar el examen de certificación, nos pondremos en contacto vía WhatsApp para proporcionarte tus códigos de acceso.",
        "button": "Crear cuenta"
      },
      "schedule": {
        "title": "Agendar Examen",
        "description": "Este es el último y más importante de todos los pasos, es necesario que agendes con nosotros tu examen de certificación, para ello da clic en el botón y llena el formulario de registro.",
        "success": "Tienes todo lo necesario para agendar tu examen",
        "error": "Aún no cuentas con lo necesario para agendar",
        "advisorError": "Aún no cuentas con lo necesario para agendar pero puedes agendar un examen para uno de tus colaboradores",
        "noMos": "Debes tener contratada tu Certificación MOS para agendar tu examen.",
        "button": "Agendar"
      }
    },
    "modals": {
      "noCertifications": {
        "title": "No tienes Certificaciones MOS asignadas",
        "description": "Asígnala desde la pestaña \"Certificaciones adquiridas\"",
        "confirm": "Entendido"
      },
      "scheduleExam": {
        "title": "Agendar examen"
      }
    },
    "notifications": {
      "purchaseSuccess": "Compra realizada con éxito. Ya puedes asignar y agendar un examen de certificación MOS"
    }
  },
  "cursoPropedeuticoMos": {
    "tooltips": {
      "tour": "Conoce tu entorno",
      "play": "Reproducir",
      "fullscreen": "Pantalla completa"
    },
    "sections": {
      "lessons": "Lecciones de apoyo",
      "projects": "Proyectos"
    },
    "buttons": {
      "downloadMaterial": "Descargar material de apoyo"
    },
    "emptyState": {
      "title": "Selecciona una lección o un proyecto para comenzar"
    }
  },
  "leccionesMOS": {
    "MOSSRC01": "Accesibilidad",
    "MOSSRC02": "Agregar una serie de datos",
    "MOSSRC03": "Aplicar formato de número",
    "MOSSRC04": "CONTAR.SI",
    "MOSSRC05": "Configurar las opciones de estilo de tabla",
    "MOSSRC06": "Insertar fila de totales",
    "MOSSRC07": "Inspeccionar un libro para comprobar si hay problemas de compatibilidad",
    "MOSSRC08": "Fórmulas IZQUIERDA, DERECHA y MEDIA",
    "MOSSRC09": "Tablas dinámicas",
    "MOSSRC10": "Modificar propiedades de formas",
    "MOSSRC11": "Ocultar y mostrar columnas",
    "MOSSRC12": "Concatenar",
    "MOSSRC13": "Ordenar columnas múltiples",
    "MOSSRC14": "SUMAR.SI",
    "MOSSRC15": "Insertar referencias",
    "MOSSRC16": "Inspeccionar propiedades",
    "MOSSRC17": "Insertar minigráficos",
    "MOSSRC18": "Modificar propiedades de un documento",
    "MOSSRC19": "Organizar datos por columnas múltiples",
    "MOSSRC20": "Texto alternativo",
    "MOSSRC21": "Insertar cuadro de texto y formas",
    "MOSSRC22": "Zoom"
  },
  "proyectosMOS": {
    "MOS16P01": "FERRETERIAMEX: Organizar, actualizar y dar formato al libro",
    "MOS16P02": "GASTOS FAMILIARES: Estudio de mercado",
    "MOS16P03": "TORNILLOS DURAMAX: Aplica fórmulas y formatos a sus listados",
    "MOS16P04": "BANCO DEL NORTE: Analiza y crea fórmulas. Agrega información para aclaraciones a clientes",
    "MOS16P05": "ROPA DEPORTIVA: Realiza análisis de ventas y representación gráfica",
    "MOS16P06": "EMPRESA MULTIPLAZA: Informe de incidentes en las diferentes áreas (Agregando formato)",
    "MOS16P07": "NÓMINA DE EMPLEADOS: Corrige errores y aplica formato"
  },
  
  "requisitosMOS": {
    "titleMOS": "¿Qué es la certificación MOS?",
    "descripcionMOS":"El objetivo de estas certificaciones Microsoft Office Specialist (MOS) es la acreditación del conocimiento, las competencias y las habilidades en el manejo de las diferentes herramientas de Microsoft Office, en sus versiones Microsoft Office 2016 y Microsoft Office 2019/365.",
    "paymentStatus": "85% payment requirement not met",
    "warningMessage": "En el caso de haber adquirido la licencia con el método de pago a crédito, deberás estar al corriente y haber liquidado al menos el 85% del total de tu licencia.",
    "noShowPolicy": "En el caso de haber adquirido la licencia con el método de pago a crédito, deberás estar al corriente y haber liquidado al menos el 85% del total de tu licencia.",
    "createAccount": "Crear cuenta",
    "requirements" : {
      "titleRequirements": "Requisitos",
      "systemRequirements": "Requisitos del sistema",
      "description": "Indispensable contar con los siguientes requisitos:",
      "intermediateExcel" : "Excel Intermedio",
      "advancedExcel" : "Excel Avanzado",
      "extraPayment" : "Realizar el pago de $2000.00mxn por el evento para su certificación MOS",
      "mosLessons" : "Lecciones del apartado propedéutico terminadas al 100%",
      "systemRequirements" : "System requirements",
      "minimumOS": "Windows (7, 10)",
      "stableInternet": "Conexión estable a internet",
    }
  },

  "extrasCertificacionMos": {
    "title" : "Tienes certificaciones MOS disponibles para asignar y agendar.",
    "subtitle": "Si aún no has asignado algúna certificación, visita el apartado de 'Certificaciones Adquiridas' de esta misma sección para asignarlas.",
  },

  
  "acquiredCertifications": {
    "title": "Datos de Certificaciones MOS",
    "acquiredCertifications": "Certificaciones adquiridas",
    "testsPerformed": "Exámenes realizados",
    "certificationsApproved": "Certificaciones aprobadas",
    "certificationsAwarded": "Certificaciones asignadas"
  },  

  "assignMOSCertification": {
    "acquired": "Adquirido(s)",
    "used": "Usado(s)",
    "completed" : "realizada(s)",
    "approved": "aprovada(s)",
    "assign": "Asignar certificación",
    "title": "Asignar certificación MOS",
    "instructions" : "Para que la persona que elegiste pueda tener acceso a su proceso de Certificación MOS, deberás darla de alta en este formulario.",
    "chooseSomeone" : "Elige quién se va a certificar",
    "chooseAPerson": "Elige a una persona",
    "chooseAnOption": "Elige una opción",
    "firstName": "Nombre(s)",
    "secondName" : "Apellidos",
    "email": "Correo electrónico",
    "phoneNumber": "Número de teléfono",
    "examDate": "Fecha del examen",
    "dateAdvice": "La fecha del examen deberá ser minimo 15 dias hábiles despues de la fecha actual.",
    "certiportUsername": "Nombre de usuario de Certiport",
    "preferredTime": "Hora deseada para tu examen",
    "timeAdvice": "El horario disponible para realizar el examen es de 9:00am a 1:00pm",
    "verifyYourInfo": "Verifica tu información",
    "confirmRequisites": "Estoy de acuerdo en que he leido todos y cada uno de los requisitos solicitados para agendar y realizar mi examen de certificación.",
    "itsMe": "Soy yo",
    "secondUser": "Usuario secundario",
    "externalPersonOption": "Persona externa", 
    "externalPerson" : 'Si la persona elegida es externa a la plataforma, tú deberás ayudarle a realizar su proceso de Certificación desde la pestaña "Certificación MOS".',
    "assignCertification": "Asignar certificación",
    "recordedAttempts": "Intentos registrados",
    "limitReached": "Has alcanzado el límite de certificaciones adquiridas, para agregar otra persona, adquiere otra Certificación MOS",
    "earnMoreMOS": "Comprar más",
    "confirmationFormMessages": {
      "noName": "Aún no has escrito un nombre",
      "noEmail" : "Escribe un correo electrónico",
      "noDate":"Aún no has seleccionado una fecha",
      "noPhone": "Agrega un teléfono de contacto",
      "noTime": "Aún no has seleccionado una hora",

    },
    "historyTable": {
      "name": "Nombre",
      "certifiedBeneficiary": "Beneficiario certificado",
      "attemptNumber": "Número de intento",
      "applicationDate": "Fecha de solicitud",
      "effectiveDate": "Fecha de aplicación",
      "examCompleted": "Examen realizado",
      "testApproved": "Examen aprobado"
    }
  },
  "scheduleExam": {
    
  }, 

  //Componente de mis pagos

  //Mis avances
  "userProgress": {
    "title": "Tu progreso",
    "aboutAccount": "Información de tu cuenta",
    "renewMessage": "No pierdas tu progreso, renueva tu licencia",
    "lastLogin": "Último ingreso a la plataforma:",
    "lastLesson": "Última lección vista:",
    "timeOnPlatform": "Tiempo en plataforma:",
    "individualProgress": "Avance individual",
    "progressByCourse": "Avance por curso",
    "progressByLesson": "Avance por lecciones",
    "completedOn": "Fecha de finalización",
    "completed": "Completado",
    "getStarted": "Por el momento no tienes ningun avance, ¿Qué esperas a comenzar...?",
    "groupProgress": "Progreso grupal",
    "businessUsers": "Usuarios empresariales",
    "checkProgress": "Ver avance",
    "noTimeOnPlatform": "Sin tiempo en plataforma",
    "progressByLessonBusiness": "Avance por lecciones del usuario empresarial",
    "lessonsCompleted": "Lecciones completadas",
    "paymentsUpToDate": "Ponte al corriente con tus pagos"
  },

  "renewLicense": "Renovar Licencia",
  "accountStatement": "Estado de cuenta",

  
  "accountStatementRequest": {
    "stepsTitle": "Para solicitar tu estado de cuenta sigue los siguientes pasos:",
    "verifyInfo": "Verifíca que tu información sea correcta antes de enviar tu solicitud.",
    "deliveryTime": "Tu estado de cuenta estará llegando en un lapso de 48 horas hábiles a la dirección de correo electrónico ingresado.",
    "confirmInfo": "Confirma tu información antes de enviar tu solicitud:",
    "settingsInstruction": "Ingresa a 'Configuración' desde el menú desplegable para modificar tus datos.",
    "getStateOfAccount": "Solicitar estado de cuenta",
    "submitting": "Solicitando...",
    "nameRequired": "Es nesesario agregar nombre y apellidos",
    "emailRequired" : "Es necesario adjuntar una dirección de correo electrónico a la solicitud",
    "phoneNumberRequired": "Es necesario registrar un número de telefono para poder continuar con la solicitud"


  },


  //business forum

  "businessForum": {
    "title": "Foro empresarial",
    "posts": "Publicaciones",
    "newPost": "Nueva publicación",
    "noPosts": "Sin publicaciones",
    "partners": "Colaboradores",
    "mosCertifications": "Certificaciones MOS",
    "reports": "Reportes",
    "activePost": "Activa",
    "inactivePost": "Inactiva",
    "editPost": "Modificat",
    "downloadFile": "Descargar material de apoyo",
    "createdAt": "Creado el ",
    "deactivatePostConfirmation": "¿Estás seguro de deshabilitar esta publicación?",
    "confirmDeactivatePost" : "Si, deshabilitar",
    "cancelDeactivatePost": "No, cancelar",
    "noDeactivated": "No se desactivó la publicación",
    "postDeactivated": "Se desactivó la publicación",
    "reactivatePost": "Reactivar publicación",
    "reactivatePostConfirmation": "¿Estás seguro de reactivar esta publicación?",
    "noReactivated": "El post no se reactivó",
    "confirmReactivatePost": "Si, reactiva la publicación",
    "cancelReactivatePost": "No, cancelar",
    "postTitle": "Título",
    "description": "Descripción de la publicación",
    "describeYourPost": "Describe tu publicación",
    "attachFile": "Adjuntar archivo",
    "currentFile": "Archivo actual",
    "fileNameAdvice" : "Asegúrate que el nombre de tu plantilla no contenga tildes ni caracteres especiales",
    "postUpdated": "Publicación actualizada exitósamente",
    "customLessons": "Lección personalizada",
    "requestCustomLesson": "Nueva lección personalizada",
    "noLessonsSelected": "No hay lecciones seleccionadas",
    "noLessonsAvailable": "No hay lecciones disponibles",
    "newCustomLesson" : "Solicitar nueva lección personalizada",
    "downloadTemplate": "Descargar plantilla",
    //Lecciones
    "lessonTitle": "Título de la lección",
    "lessonDescription": "Descripción de la lección",
    "lessonContent": "Contenido de la lección",
    "downloadableContent": "Contenido descargable",
    "downloadableContentDescription": "Este archivo contiene material adicional a tu lección y estará disponible para descargar",
    "fileInvalid": "El archivo que intenta enviar es inválido, intente de nuevo.",
    "lessonRequestedTitle": "Solicitúd de lección personalizada",
    "lessonRequestedDescription": "Tu solicitúd ha sido enviada",
    //Colaboradores
    "coworkers": {
      "registrationsAvailable": "Registros disponibles",
      "addCoworker": "Agregar colaborador",
      "inviteRegistered": "Invitar a un usuario registrado",
      "advisor": "Asesor",
      "advisors": "Asesores",
      "coworker": "Colaborador",
      "coworkers": "Colaboradores",
      "guestUsers": "Usuarios invitados",
      "anyoneInvited" :"No has invitado a nadie al grupo",
      "newBusinessUser": "Nuevo usuario empresarial",
      "signUpCoworker": "Registrar colaborador",
      "inviteCoworkerAdvice": "Escribe la dirección de correo ligada a la cuenta que deseas agregar. Cuando finalice, el usuario deberá:",
      "coworkerInvitedInstructions": "Cerrar sesión e iniciar nuevamente",
      "addToGroup": "Agregar al grupo",
      "userAdded": "Usauario agregado con éxito",
      "userNotAdded": "Hubo un problema al agregar al usuario, contacta a soporte técnico",
      "userDetails": "Ver información",
      "editUserInfo": "Modificar información",
      "viewProgress": "Ver avances",
      "viewMyProgress": "Ver mis avances",
      "removeFromGroup": "Remover del grupo empresarial",

    }
    
  }



}